module.exports = __webpack_public_path__ + "static/media/is.cb0715a4.svg";